import Space from "antd/lib/space";
import React, { memo } from "react";

import { CasinoColorfulIcon, CasinoIcon } from "@pages/casino/assets/icons";

const CasinoTab = ({ translate }) => {
	const isColorful = window.CASINO_TABS_HAS_COLORFUL_ICONS;

	return (
		<Space>
			{isColorful ? <CasinoColorfulIcon /> : <CasinoIcon />}
			<span>{translate("casino.casino")}</span>
		</Space>
	);
};

export default memo(CasinoTab);
